import { render } from "./SolveSolution.vue?vue&type=template&id=9ab82b74&ts=true"
import script from "./SolveSolution.vue?vue&type=script&lang=ts"
export * from "./SolveSolution.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__